class TC_Channels {
    constructor (player, systemMessages, remoteData, timetableCache) {        
        this.user = {
            id: null,
            login: null,
            token: null,
            isVip: false,
            geo: {
                ip_city: '',
                ip_region: '',
                ip_country: ''
            }
        };
        this.remoteData = remoteData;
        this.timetableCache = timetableCache;
        this.wrapper = $('.calmchristian-channels');
        this.systemMessages = systemMessages;
        this.currentChannelID = false;
        this.currentGenreID = false;
        this.artsUrl = 'https://arts.' + window.CSITE.appDomain;
        this.templateUrl = window.CSITE.templateUrl;
        this.playerInstance = player;
        this.playerInstance.channels = this;
        this.closeTimeout = false;

        // Run
        if (this.wrapper.length) {
            this.channelsUI = {
                rows: new TC_Channels_Rows(),
                categories: new TC_Channels_Categories(this, this.playerInstance, this.artsUrl, this.templateUrl)
            };
            this.segmentIntegration = new TC_SegmentIntegration(this);
            this.getUserData();
            this.loadRemoteData();
            this.initKeyboardShortcuts();
            this.initGlobalEvents();
        }
    }

    initKeyboardShortcuts () {
        $(document).on('keydown', evt => {
            if (evt.target.tagName !== 'BODY') {
                return;
            }

            if (evt.keyCode === 32) {
                evt.preventDefault();
                if (this.playerInstance && this.playerInstance.UI && this.playerInstance.UI.buttons) {
                    this.playerInstance.UI.buttons.play.trigger('click');
                }
            }
        });
    }

    loadRemoteData () {
        $.when(
            this.loadUserGeo(),
            this.loadCategories(), 
            this.loadChannels(), 
            this.loadHistory(), 
            this.loadOpinions(),
            this.loadFavorites(),
            this.loadStories()
        ).then(() => {
            this.playerInstance.initPlayer();
            this.segmentIntegration.init();
            this.segmentIntegration.initEvents();
            this.setPaidAndAtmosphericChannels();
            this.generateChannelsWithStories();
            this.channelsUI.rows.setRemoteData(this.remoteData.rows)
            this.channelsUI.categories.setRemoteData(this.remoteData);
            this.channelsUI.rows.generateRows(this.channelsUI.categories);
            this.currentChannelID = this.remoteData.history[0];
            this.playerInstance.checkChannelFavoritesStatus();
            $(document).trigger('channelsAllDataLoaded');
        }, () => {
            this.wrapper.addClass('has-loading-error');
            $(document).trigger('channelsLoadError');
        });
    }

    getUserData () {
        this.user.id = parseInt(document.body.getAttribute('data-current-id'), 10);
        this.user.login = Cookies.get('ice-login');
        this.user.token = Cookies.get('ice-token');
        this.user.isVip = !!parseInt(Cookies.get('ice-vip'), 10);
    }

    loadCategories () {
        return $.get('https://api.' + window.CSITE.appDomain + '/v2/metadata.json', (data, status) => {
            if (!(status === 'success' && data && data.metadata)) {
                this.wrapper.addClass('has-loading-error');
                return;
            }

            if (status === 'success') {
                this.remoteData.rows = data.metadata.rows;
                this.remoteData.rows = this.remoteData.rows.filter(row => row.kind === 'genre');
                this.remoteData.categories = data.metadata.categories;
            }
        });
    }

    loadChannels () {
        return $.get('https://api.' + window.CSITE.appDomain + '/v2/channels.json', (data, status) => {
            if (!(status === 'success' && data && data.channels)) {
                this.wrapper.addClass('has-loading-error');
                return;
            }

            if (status === 'success') {
                this.remoteData.channels = data.channels;
                $(document).trigger('channelsDataLoad');
            }
        });
    }

    loadHistory () {
        let historyUrl = `https://api.${window.CSITE.appDomain}/v2/last_channels?username=${this.user.login}&token=${this.user.token}`;

        return $.get(historyUrl, (data, status) => {
            if (!(status === 'success' && data && data.channels)) {
                this.wrapper.addClass('has-loading-error');
                return;
            }
            
            this.remoteData.history = JSON.parse(JSON.stringify(data.channels));
            this.remoteData.lastListenedChapters = JSON.parse(JSON.stringify(data.chapters));
            this.remoteData.finishedStories = JSON.parse(JSON.stringify(data.stories));
            $(document).trigger('channelsHistoryDataLoad');
        });
    }

    loadFavorites () {
        let favoritesUrl = window.CSITE.baseUrl + `/player/favorites.php?login=${this.user.login}&token=${this.user.token}&action=list`;

        return $.get(favoritesUrl, (data, status) => {
            if (!(status === 'success' && data)) {
                this.wrapper.addClass('has-loading-error');
                return;
            }

            if (data.map) {
                this.remoteData.favorites = data.map(id => parseInt(id, 10)).slice();
            }
        });
    }

    loadOpinions () {
        let opinionsUrl = `https://api.${window.CSITE.appDomain}/opinions/channels?username=${this.user.login}&token=${this.user.token}`;

        $.get(opinionsUrl, (data, status) => {
            if (!(status === 'success' && data)) {
                this.wrapper.addClass('has-loading-error');
                return;
            }

            if (status === 'success') {
                this.remoteData.opinions = JSON.parse(JSON.stringify(data.opinions));
            }
        });
    }

    loadStories () {
        let storiesUrl = 'https://api.' + window.CSITE.appDomain + '/v2/stories.json';

        return $.get(storiesUrl, (data, status) => {
            if (!(status === 'success' && data)) {
                this.wrapper.addClass('has-loading-error');
                return;
            }
            
            this.remoteData.stories = JSON.parse(JSON.stringify(data));
            $(document).trigger('channelsStoriesDataLoad');
        });
    }

    generateChannelsWithStories () {
        for (let i = 0; i < this.remoteData.stories.length; i++) {
            let id = this.remoteData.stories[i].id;
            let timetableUrl = this.remoteData.stories[i].timetable;
            let streamUrl = this.remoteData.stories[i].url;
            this.remoteData.storiesTimetables[id] = timetableUrl;
            this.remoteData.storiesStreams[id] = streamUrl;
        }

        for (let j = 0; j < this.remoteData.channels.length; j++) {
            // VIP-only chapters!
            if (this.remoteData.channels[j].story && this.checkIfStoriesExistsForChannel(this.remoteData.channels[j].vip)) {
                let channelID = this.remoteData.channels[j].id;
                this.remoteData.channelsWithStories.push(channelID);
                this.remoteData.channelsToStoryMap[channelID] = this.remoteData.channels[j].vip[0].id;
            }
        }
    }

    checkIfStoriesExistsForChannel(channelData) {
        let availableStories = this.remoteData.stories.map(story => story.id);
        let channelStories = channelData.map(track => track.id);

        for (let i = 0; i < channelStories.length; i++) {
            if (availableStories.indexOf(channelStories[i]) === -1) {
                return false;
            }
        }

        return true;
    }

    isPaidChannel (channelID) {
        return this.remoteData.paidChannels.indexOf(channelID) > -1;
    }

    setPaidAndAtmosphericChannels () {
        // get paid channels
        let paidChannels = this.remoteData.channels.filter(channel => !channel.free || (channel.free && channel.free.length === 0)).map(channel => channel.id);
        this.remoteData.paidChannels = paidChannels;
    }

    isInFavorites (channelID) {
        if (!this.remoteData.favorites) {
            return false;
        }

        return this.remoteData.favorites.indexOf(channelID) > -1;
    }

    addToFavorites (channelID, callback) {
        channelID = parseInt(channelID, 10);
        let url = window.CSITE.baseUrl + `/player/favorites.php?login=${this.user.login}&token=${this.user.token}&action=add&id=${channelID}`;

        $.get(url, (data, status) => {
            if (status === 'success') {
                this.remoteData.favorites.unshift(channelID);
                $(document).trigger('userFavoritesChanged', ['fav', channelID]);
                callback();
                $('*[data-channel-id="' + channelID + '"]').addClass('is-favorited');
            }
        });
    }

    removeFromFavorites (channelID, callback) {
        channelID = parseInt(channelID, 10);
        let url = window.CSITE.baseUrl + `/player/favorites.php?login=${this.user.login}&token=${this.user.token}&action=remove&id=${channelID}`;

        $.get(url, (data, status) => {
            if (status === 'success') {
                this.remoteData.favorites = this.remoteData.favorites.filter(id => id !== channelID).slice();
                $(document).trigger('userFavoritesChanged', ['unfav', channelID]);
                callback();
                $('*[data-channel-id="' + channelID + '"]').removeClass('is-favorited');
            }
        });
    }

    likeChannel (channelID, callback) {
        channelID = parseInt(channelID, 10);
        let url = `https://api.${window.CSITE.appDomain}/opinions/channels/${channelID}/like?username=${this.user.login}&token=${this.user.token}`;

        $.get(url, (data, status) => {
            if (status === 'success') {
                this.remoteData.opinions[channelID] = 1;
                callback();
                $('*[data-channel-id="' + channelID + '"]').addClass('is-liked').removeClass('is-disliked');
            }
        });
    }

    dislikeChannel (channelID, callback) {
        channelID = parseInt(channelID, 10);
        let url = `https://api.${window.CSITE.appDomain}/opinions/channels/${channelID}/dislike?username=${this.user.login}&token=${this.user.token}`;

        $.get(url, (data, status) => {
            if (status === 'success') {
                this.remoteData.opinions[channelID] = -1;
                callback();
                $('*[data-channel-id="' + channelID + '"]').addClass('is-disliked').removeClass('is-liked');
            }
        });
    }

    initGlobalEvents () {
        $(document).on('playingStateChanged', (event, isPlaying) => {
            let currentChannelID = parseInt(this.playerInstance.currentChannel.id, 10);
            let expandedWrapper = $(document.body).find('.calmchristian-channels-expanded[data-expanded-channel="' + currentChannelID + '"]');

            if (!expandedWrapper.length) {
                return;
            }
            
            let btn = expandedWrapper.find('.calmchristian-channels-expanded-content-play');

            if (btn.length) {
                if (isPlaying === true) {
                    btn.html(DOMPurify.sanitize(btn.attr('data-text-pause')));
                } else {
                    if (this.remoteData.lastListenedChapters[currentChannelID] === 1 && this.remoteData.finishedStories.indexOf(currentChannelID) > -1) {
                        btn.html(DOMPurify.sanitize(btn.attr('data-text-listen-again')));
                    } else if (this.remoteData.lastListenedChapters[currentChannelID] === 1) {
                        btn.html(DOMPurify.sanitize(btn.attr('data-text-play')));
                    } else {
                        btn.html(DOMPurify.sanitize(btn.attr('data-text-resume')));
                    }
                }
            }
        });
    }

    loadUserGeo () {
        let geoUrl = `https://api.${window.CSITE.appDomain}/geo`;

        return $.ajax({
            url: geoUrl, 
            type: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                user: this.user.login,
                token: this.user.token
            })
        }).done(response => {
            if (!response) {
                this.wrapper.addClass('has-loading-error');
                return;
            }

            try {
                response = JSON.parse(response);
            } catch (e) {
                this.wrapper.addClass('has-loading-error');
                return;
            }

            if (response.ip_city) {
                this.user.geo.ip_city = response.ip_city;
            }

            if (response.ip_region) {
                this.user.geo.ip_region = response.ip_region;
            }

            if (response.ip_country) {
                this.user.geo.ip_country = response.ip_country;
            }
            
            $(document).trigger('userGeoDataLoad');
        });
    }
}
